/*
    参考にしたサイト
    
    【jQueryでリスト表示を絞り込む処理を実装する】
    https://www.tam-tam.co.jp/tipsnote/javascript/post14636.html
*/

var searchBox = ".Page-CorporateCustomer .Chip-Bar ul"; // 絞り込む項目を選択するエリア
var listItem = ".searched-item"; // 絞り込み対象のアイテム
var hideClass = "hidden"; // 絞り込み対象外の場合に付与されるclass名

var filter_name_arr = {
  novelty: {
    title: "ノベルティ",
    desc: "記念品や、取引先への配布用としてAnkerの製品をご使用いただけます。<br /> ロゴやメッセージなどを製品に印字してオリジナルのグッズを作成することも可能です。",
  },
  // 'in-house-use': { 'title': '自社利用', 'desc': '自社利用の説明' },
  alliance: {
    title: "他企業との協業",
    desc: "Ankerグループでは国内外の幅広いクライアントとの協業を通じ、様々な製品の展開を行ってきました。",
  },
  licensed: {
    title: "ライセンス製品",
    desc: "Ankerグループではグローバルブランドのライセンスを取得した製品の展開を行っています。",
  },
  office: {
    title: "オフィス",
    desc: "Ankerの会議用スピーカーや高画質ウェブカメラを活用いただくことで、快適なリモート会議を実現します。<br /> また、スマートフォンやノートPCの急速充電に対応したコンパクトサイズの充電器もおすすめです。",
  },
  hotel: {
    title: "ホテル",
    desc: "客室にAnkerグループのスマートプロジェクターやBluetoothスピーカーを設置することで、お客様のより快適な滞在を実現します。<br /> 会議室でのご利用向けに、リモート会議を快適にする会議用スピーカーもおすすめです。",
  },
  school: {
    title: "学校",
    desc: "オンライン授業をより快適にするため、会議用スピーカーやウェブカメラなどをご利用いただけます。<br /> また災害時の非常用電源として、Ankerのポータブル電源をご活用いただけます。",
  },
  public: {
    title: "公共施設",
    desc: "災害時の非常用電源としてAnkerのポーダブル電源やモバイルバッテリー、ケーブルをご使用いただけます。",
  },
  others: {
    title: "その他",
    desc: "さまざまな用途・場所でAnkerグループの製品をご使用いただけます。",
  },
  powerbank: { title: "モバイルバッテリー", desc: "の説明" },
  charger: { title: "充電器", desc: "の説明" },
  "portable-power-supply": { title: "ポータブル電源", desc: "の説明" },
  "cable-usbhub": { title: "ケーブル / USBハブ", desc: "の説明" },
  "confspeaker-webcam": {
    title: "会議用スピーカー / ウェブカメラ",
    desc: "の説明",
  },
  "earphone-headphone": { title: "イヤホン / ヘッドホン", desc: "の説明" },
  speaker: { title: "スピーカー", desc: "の説明" },
  cleaner: { title: "ロボット掃除機", desc: "の説明" },
  projector: { title: "プロジェクター", desc: "の説明" },
};

$(function () {
  // 絞り込み項目を変更した時
  $(document).on("change", searchBox + " input", function () {
    search_filter();
    recommend_products();
    change_header();
    change_title();
  });

  /* SP時のトグルメニュー */
  // 開ける
  $(".Menu .openBtn").on("click", function () {
    $(".Menu .body").toggleClass("open");
    $(".Page-CorporateCustomer").toggleClass("darker");
  });

  // 閉じる
  $(".Menu .closeBtn").on("click", function () {
    $(".Menu .body").toggleClass("open");
    $(".Page-CorporateCustomer").toggleClass("darker");
  });

  /* カードのサムネイル画像 */
  $(".sub-img li").on("click", function () {
    const $thumbnail = $(this);
    const $mainImg = $thumbnail.closest(".searched-item").find(".main-img img");
    const $thumbnailImg = $thumbnail.find("img");

    // クリックされたサムネイルの画像URLを取得
    const newSrc = $thumbnailImg.attr("src");

    // 現在のメイン画像のURLを取得
    const currentSrc = $mainImg.attr("src");

    // 画像のベースURLを比較（サイズパラメータを除去）
    const getBaseUrl = (url) => {
      return url.split("?")[0];
    };

    // すでに同じ画像が表示されている場合は何もしない
    if (getBaseUrl(currentSrc) === getBaseUrl(newSrc)) {
      return;
    }

    // アクティブクラスの切り替え
    $thumbnail.siblings().removeClass("active");
    $thumbnail.addClass("active");

    // 新しい画像を事前に読み込む
    const newImg = new Image();
    newImg.src = newSrc;

    // 画像の読み込みが完了したら切り替えを実行
    newImg.onload = function () {
      $mainImg.fadeOut(200, function () {
        $mainImg.attr("src", newSrc).fadeIn(200);
      });
    };

    // 画像の読み込みに失敗した場合のエラーハンドリング
    newImg.onerror = function () {
      console.error("画像の読み込みに失敗しました:", newSrc);
    };
  });

  // position: sticky;を効かせるために、この要素の全ての先祖要素のoverflowをvisibleに
  $(".Sidebar").parents().css("overflow", "visible");

  // group内のチェックボックスは１つしか選択できないように
  var uniquecheck = $(searchBox).find("input[type=radio]");
  uniquecheck.click(function () {
    var group = $(this).attr("name");
    uniquecheck
      .filter(function () {
        return $(this).attr("name") == group;
      })
      .not(this)
      .removeAttr("checked");

    $(this).parent().siblings().removeClass("active");
    if ($(this).parent().hasClass("active")) {
      $(this).parent().removeClass("active");
    } else {
      $(this).parent().addClass("active");
    }
  });
});

/**
 * リストの絞り込みを行う
 */
function search_filter() {
  // 非表示状態を解除
  $(listItem).removeClass(hideClass);
  for (var i = 0; i < $(searchBox).length; i++) {
    var name = $(searchBox).eq(i).find("input").attr("name");

    // 選択されている項目を取得
    var searchData = get_selected_input_items(name);

    // 選択されている項目がない場合は飛ばす
    if (searchData.length === 0 || searchData[0] === "") {
      continue;
    }

    // リスト内の各アイテムをチェック
    for (var j = 0; j < $(listItem).length; j++) {
      // アイテムに設定している項目を取得
      var itemData = get_setting_values_in_item($(listItem).eq(j), name);

      // 絞り込み対象かどうかを調べる
      var check = array_match_check(itemData, searchData);
      if (!check) {
        $(listItem).eq(j).addClass(hideClass);
      }
    }
  }

  if (
    $(".Company ul.searched-items li.searched-item").not(".hidden").length == 0
  ) {
    $(".Company .no-match").removeClass(hideClass);
  } else {
    $(".Company .no-match").addClass(hideClass);
  }
}

function change_header() {
  for (var i = 0; i < $(searchBox).length; i++) {
    var name = $(searchBox).eq(i).find("input").attr("name");
    var searchData = get_selected_input_items(name);

    if (name === "scene") {
      var target = ".Header";
      if (searchData.length !== 0) {
        $(".Intro").addClass("hidden");
        $(target).removeClass("hidden");
        $(target).find("h2 span.scene").text(filter_name_arr[searchData].title);
        $(target).find("p").html(filter_name_arr[searchData].desc);
      } else {
        $(".Intro").removeClass("hidden");
        $(target).addClass("hidden");
      }
    } else if (name === "product" && searchData.length !== 0) {
      $(".Intro").addClass("hidden");
    }
  }
}

function change_title() {
  var text_added = [];

  for (var i = 0; i < $(".Sidebar ul").length; i++) {
    var name = $(".Sidebar ul").eq(i).find("input").attr("name");

    // 選択されている項目を取得
    var searchData = get_selected_input_items(name);
    if (filter_name_arr[searchData]) {
      text_added.push(filter_name_arr[searchData].title);
    }
  }

  var target = $(".Company h2 .selected-input");
  if (text_added.length !== 0) {
    target.text("（" + text_added.join("、") + "）:");
  } else {
    target.text("");
  }
}

function recommend_products() {
  console.log(
    $(".Recommendation ul.recommend-items li.searched-item").not(".hidden")
      .length
  );
  if (
    $(".Recommendation ul.recommend-items li.searched-item").not(".hidden")
      .length == 0
  ) {
    $(".Recommendation").addClass(hideClass);
  } else {
    $(".Recommendation").removeClass(hideClass);
  }
}

function get_selected_input_items(name) {
  var searchData = [];
  $("input[name=" + name + "]:checked").each(function () {
    searchData.push($(this).val());
  });

  return searchData;
}

function get_setting_values_in_item(target, data) {
  var itemData = target.data(data);
  if (!Array.isArray(itemData)) {
    itemData = [itemData];
  }
  return itemData;
}

function array_match_check(arr1, arr2) {
  // 絞り込み対象かどうかを調べる
  var arrCheck = true;

  for (var i = 0; i < arr2.length; i++) {
    if (arr1.indexOf(arr2[i]) == -1) {
      arrCheck = false;
    }
  }
  return arrCheck;
}
